import React, { useState, useEffect, useRef } from 'react';
import Drawer from 'react-modern-drawer';
import 'react-modern-drawer/dist/index.css';
import { useForm } from 'react-hook-form';
import { translateData, getLanguages, getCrops, addCropWisePrePost, updateCropWisePrePost } from '../lib/api';
import { RichTextEditor } from './child/RichTextEditor';
import { Icon } from '@iconify/react/dist/iconify.js';
import { toast } from 'react-toastify';

const customStyles = `
  .form-grid-container {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 1.5rem !important;
    width: 100% !important;
    margin-bottom: 1.25rem !important;
  }
  .form-control, textarea {
    width: 100% !important;
    border-radius: 8px !important;
    padding: 8px 12px !important;
    border: 1px solid #ced4da !important;
    background: #fff !important;
  }
  .error-message { color: #dc3545; font-size: 0.75rem; }
  .success-message { color: #28a745; text-align: center; margin-bottom: 1rem; }

  /* Rich Text Editor Styles */
  .rich-text-editor {
    border: 1px solid #ced4da;
    border-radius: 8px;
    overflow: hidden;
  }
  
  .toolbar {
    display: flex;
    gap: 8px;
    padding: 8px 12px;
    background: #f8f9fa;
    border-bottom: 1px solid #ced4da;
  }
  
  .toolbar-btn {
    padding: 6px 12px;
    border: 1px solid #dee2e6;
    background: white;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
  }
  
  .toolbar-btn:hover {
    background: #e9ecef;
  }
  
  .toolbar-btn.active {
    background: #0d6efd;
    color: white;
    border-color: #0d6efd;
  }
  
  .editor-content {
    min-height: 200px;
    padding: 12px;
    outline: none;
    max-height: 300px;
    overflow-y: auto;
  }
  
  .editor-content:empty::before {
    content: 'Enter content...';
    color: #6c757d;
  }

  /* Main Tabs */
  .main-tabs { display: flex; gap: 8px; margin-bottom: 12px; }
  .main-tab {
    padding: 8px 14px;
    border: 1px solid #e5e7eb;
    background: #f9fafb;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
  }
  .main-tab.active {
    background: #e8f0fe;
    border-color: #1a73e8;
    color: #1a73e8;
  }

  .drawer-content-scroll {
    height: calc(100vh - 40px);
    overflow-y: auto !important;
    padding-right: 10px;
  }

  .activity-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 1rem;
    border: 1px solid #e5e7eb;
  }
  
  .activity-table th {
    background: #f8f9fa;
    padding: 12px;
    text-align: left;
    border: 1px solid #dee2e6;
    font-weight: 600;
    color: #495057;
  }
  
  .activity-table td {
    padding: 12px;
    border: 1px solid #dee2e6;
    vertical-align: middle;
  }
  
  .activity-table tr:hover {
    background: #f8f9fa;
  }

  .table-actions {
    display: flex;
    gap: 8px;
  }

  .radio-group {
    display: flex;
    gap: 20px;
    margin-bottom: 1rem;
  }

  .radio-option {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
  }

  .radio-option input[type="radio"] {
    margin: 0;
  }

  .summary-textarea {
    width: 100%;
    min-height: 100px;
    border: 1px solid #ced4da;
    border-radius: 8px;
    padding: 8px 12px;
    resize: vertical;
  }

  .summary-counter {
    text-align: right;
    font-size: 0.75rem;
    color: #6b7280;
    margin-top: 4px;
  }

  .card-body {
    overflow-y: auto !important;
    max-height: 100vh !important;
    padding: 1.5rem !important;
    overscroll-behavior: contain !important;
  }
    .main-tabs { 
    display: flex; 
    gap: 8px; 
    margin-bottom: 12px; 
    border-bottom: 1px solid #e5e7eb;
    padding-bottom: 12px;
  }
  .main-tab {
    padding: 8px 14px;
    border: 1px solid #e5e7eb;
    background: #f9fafb;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
  }
  .main-tab.active {
    background: #e8f0fe;
    border-color: #1a73e8;
    color: #1a73e8;
  }

  /* Language Sub-Tabs - Updated to match General Topic */
  .lang-tabs { 
    display: flex; 
    gap: 8px; 
    flex-wrap: wrap; 
    margin-bottom: 20px;
    border-bottom: 1px solid #e5e7eb;
    padding-bottom: 12px;
  }
  .lang-tab {
    padding: 6px 12px;
    border: 1px solid #e5e7eb;
    background: #f9fafb;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 500;
    font-size: 0.875rem;
  }
  .lang-tab.active {
    background: #e8f0fe;
    border-color: #1a73e8;
    color: #1a73e8;
  }
`;

export default function AddCropWisePrePost({ isOpen, onClose, onSaveSuccess, activityToEdit }) {
    const [message, setMessage] = useState(null);
    const [step, setStep] = useState('basic'); // 'basic' | 'translate' | 'translations'
    const [mainTab, setMainTab] = useState('english'); // 'english' | 'other'
    const [languages, setLanguages] = useState([]);
    const [crops, setCrops] = useState([]);
    const [contents, setContents] = useState({}); // For Content rich text
    const [summaries, setSummaries] = useState({}); // For Summary text
    const [loadingLanguages, setLoadingLanguages] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState('');
    const [activities, setActivities] = useState([]); // For storing added activities table
    const [activityContents, setActivityContents] = useState({});
    const [activitySummaries, setActivitySummaries] = useState({});
    const [editingActivityIndex, setEditingActivityIndex] = useState(null);
    const [editingLanguage, setEditingLanguage] = useState('');
    const [selectedCropId, setSelectedCropId] = useState('');
    const [selectedCropName, setSelectedCropName] = useState('');

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        setValue,
        getValues,
        watch,
        trigger,
        setError,
        clearErrors
    } = useForm({
        defaultValues: {
            cropId: activityToEdit?.CropID || '',
            isPre: null,
            weekNo: '',
            sameActivityForWeeks: 0,
        },
    });

    const isPre = watch('isPre');
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isOpen]);

    // Clear editing state when drawer is closed to avoid stale edit UI
    useEffect(() => {
        if (!isOpen) {
            setEditingActivityIndex(null);
            setEditingLanguage('');
            setContents({});
            setSummaries({});
        }
    }, [isOpen]);

    // Load crops and languages
    useEffect(() => {
        const loadData = async () => {
            if (!isOpen) return;

            try {
                const token = localStorage.getItem('authToken') || localStorage.getItem('token');

                // Crops
                const cropsRes = await getCrops(token);
                if (cropsRes) {
                    const sortedCrops = (cropsRes || []).sort((a, b) =>
                        a.CropName?.localeCompare(b.CropName)
                    );
                    setCrops(sortedCrops);
                } else if (cropsRes?.data) {
                    const sortedCrops = cropsRes.data.sort((a, b) =>
                        a.CropName?.localeCompare(b.CropName)
                    );
                    setCrops(sortedCrops);
                }

                // Languages
                setLoadingLanguages(true);
                const languagesRes = await getLanguages();
                let languagesList = [];
                if (languagesRes?.status === 'success' && languagesRes?.data) {
                    languagesList = languagesRes.data;
                } else if (Array.isArray(languagesRes?.data)) {
                    languagesList = languagesRes.data;
                } else if (Array.isArray(languagesRes)) {
                    languagesList = languagesRes;
                }

                const activeLanguages = languagesList.filter(lang =>
                    lang.IsLanguageActivated === true || lang.IsLanguageActivated === 1 ||
                    lang.IsActive === true || lang.IsActive === 1 ||
                    lang.IsActivated === true || lang.IsActivated === 1
                );

                setLanguages(activeLanguages);

                // Set default selected language
                if (activeLanguages.length > 0) {
                    const nonEnglish = activeLanguages.find(lang =>
                        (lang.GoogleLanguageCode !== 'en' && lang.GoogleLanguageCode !== 'en-US')
                    );
                    if (nonEnglish) {
                        setSelectedLanguage(nonEnglish.GoogleLanguageCode || nonEnglish.LanguageCode);
                    }
                }

            } catch (error) {
                console.error('Failed to load data:', error);
                toast.error(`Failed to load data: ${error.message}`);
            } finally {
                setLoadingLanguages(false);
            }
        };

        loadData();
    }, [isOpen]);

    // Prefill data for edit mode
    useEffect(() => {
        if (!isOpen) return;

        setMessage(null);
        setMainTab('english');
        setActivities([]);
        setSelectedCropId('');
        setSelectedCropName('');
        setContents({});
        setSummaries({});
        setActivityContents({});
        setActivitySummaries({});

        if (activityToEdit) {
            // Set Form Values
            setValue('cropId', activityToEdit.CropID || '');
            setValue('isPre', null);

            // Set crop name and ID
            setSelectedCropId(activityToEdit.CropID);
            setSelectedCropName(activityToEdit.CropName || 'Unknown Crop');

            // Parse existing activities from details
            if (activityToEdit.CropWisePrePostSowingDet &&
                Array.isArray(activityToEdit.CropWisePrePostSowingDet)) {

                // Group by IsPre and WeekNo to get unique activities
                const activityMap = new Map();
                const allActivityContents = {};
                const allActivitySummaries = {};

                // First pass: create activity entries and store all language data
                activityToEdit.CropWisePrePostSowingDet.forEach(detail => {
                    const key = `${detail.IsPre}-${detail.WeekNo}`;
                    const langCode = detail.GoogleLanguageCode || detail.LanguageCode;
                    //for every data to be differentiate for language in each table
                    if (!activityMap.has(key)) {
                        const activityId = `${detail.IsPre}-${detail.WeekNo}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
                        activityMap.set(key, {
                            ID: activityId,
                            CropID: activityToEdit.CropID,
                            IsPre: detail.IsPre ? 1 : 0,
                            WeekNo: detail.WeekNo,
                            SameActivityForWeeks: detail.ExtendedTillNoOfWeeks || 0,
                            isNew: false
                        });

                        allActivityContents[activityId] = {};
                        allActivitySummaries[activityId] = {};
                    }

                    // Store content for each language
                    const activityId = activityMap.get(key).ID;
                    allActivityContents[activityId][langCode] = detail.Content || '';
                    allActivitySummaries[activityId][langCode] = detail.Summary || '';
                });

                const parsedActivities = Array.from(activityMap.values());

                setActivities(parsedActivities);
                setActivityContents(allActivityContents);
                setActivitySummaries(allActivitySummaries);

                // Also populate global contents/summaries with first language data for English tab
                const contentsObj = {};
                const summariesObj = {};
                const englishLang = languages.find(lang => {
                    const langCode = lang.GoogleLanguageCode || lang.LanguageCode;
                    return langCode === 'en' || langCode === 'en-US' || langCode === 'en-GB';
                });
                const englishLangCode = englishLang ? (englishLang.GoogleLanguageCode || englishLang.LanguageCode) : 'en';

                // Find English content from the details
                const englishDetail = activityToEdit.CropWisePrePostSowingDet.find(
                    d => (d.GoogleLanguageCode || d.LanguageCode) === englishLangCode
                );
                if (englishDetail) {
                    contentsObj[englishLangCode] = englishDetail.Content || '';
                    summariesObj[englishLangCode] = englishDetail.Summary || '';
                }

                setContents(contentsObj);
                setSummaries(summariesObj);
            }
        } else {
            // Reset for New Entry
            reset({
                cropId: '',
                isPre: null,
                weekNo: '', 
                sameActivityForWeeks: 0
            });
        }
        // Set step to basic for both new and edit mode - user will click Translate when ready
        setStep('basic');
    }, [activityToEdit, isOpen, languages]);


    const callTranslateApi = async ({ Content, Summary }) => {
        try {
            // Validate that content and summary are not empty
            if (!Content?.trim() || !Summary?.trim()) {
                console.error('Content or Summary is empty');
                throw new Error('Content and Summary cannot be empty');
            }

            const res = await translateData({
                Content: Content.trim(),
                Summary: Summary.trim()
            });

            const maybeData = res?.data ?? res ?? {};

            const data = maybeData?.data && (maybeData.Content === undefined)
                ? maybeData.data
                : maybeData;

            const normalized = { Content: {}, Summary: {} };

            if (languages.length > 0) {
                languages.forEach(lang => {
                    const langCode = lang.GoogleLanguageCode || lang.LanguageCode;
                    normalized.Content[langCode] =
                        data.Content?.[langCode] || data.Content?.en || Content;

                    normalized.Summary[langCode] =
                        data.Summary?.[langCode] || data.Summary?.en || Summary;
                });
            } else {
                normalized.Content.en = data?.Content?.en || Content;
                normalized.Summary.en = data?.Summary?.en || Summary;
            }

            return normalized;
        } catch (err) {
            console.error('Translate API error: ', err);

            const fallback = { Content: {}, Summary: {} };
            if (languages.length > 0) {
                languages.forEach(lang => {
                    const langCode = lang.GoogleLanguageCode || lang.LanguageCode;
                    fallback.Content[langCode] = Content;
                    fallback.Summary[langCode] = Summary;
                });
            } else {
                fallback.Content.en = Content;
                fallback.Summary.en = Summary;
            }
            return fallback;
        }
    };

    const handleAddActivity = async () => {
        // Validate form
        const isValid = await trigger(['cropId', 'isPre', 'weekNo']);
        if (!isValid) {
            toast.error('Please fill all required fields correctly');
            return;
        }

        const formData = getValues();
        const weekNoInt = parseInt(formData.weekNo);
        const isPreInt = parseInt(formData.isPre);

        // Check for duplicate combination of IsPre and Week No.
        const isDuplicate = activities.some(activity =>
            activity.IsPre === isPreInt &&
            activity.WeekNo === weekNoInt
        );

        if (isDuplicate) {
            setError('weekNo', {
                type: 'manual',
                message: 'Activity with this week number already exists for the selected type'
            });
            toast.error('Activity with this week number already exists');
            return;
        }

        clearErrors('weekNo');

        // Get English content
        const englishLang = getEnglishLanguage();
        const englishLangCode = getLanguageCode(englishLang);
        const englishContent = contents[englishLangCode] || '';
        const englishSummary = summaries[englishLangCode] || '';

        if (!englishContent.trim()) {
            toast.error('Please enter activity content in English');
            return;
        }

        if (!englishSummary.trim()) {
            toast.error('Please enter summary in English');
            return;
        }

        // Validate summary length
        if (englishSummary.length > 1000) {
            toast.error('Summary must be less than 1000 characters');
            return;
        }

        const newActivity = {
            ID: Date.now(), // Temporary ID for local management
            CropID: parseInt(formData.cropId),
            CropName: crops.find(c => c.ID === parseInt(formData.cropId))?.CropName || '',
            IsPre: isPreInt,
            WeekNo: weekNoInt,
            SameActivityForWeeks: parseInt(formData.sameActivityForWeeks),
            isNew: true
        };

        // Store English content for this activity
        const updatedContents = { ...activityContents };
        const updatedSummaries = { ...activitySummaries };

        if (!updatedContents[newActivity.ID]) updatedContents[newActivity.ID] = {};
        if (!updatedSummaries[newActivity.ID]) updatedSummaries[newActivity.ID] = {};

        updatedContents[newActivity.ID][englishLangCode] = englishContent;
        updatedSummaries[newActivity.ID][englishLangCode] = englishSummary;

        setActivityContents(updatedContents);
        setActivitySummaries(updatedSummaries);
        setActivities(prev => [...prev, newActivity]);

        // Reset form fields but keep crop selection
        setValue('isPre', null);
        setValue('weekNo', '');
        setValue('sameActivityForWeeks', 0);

        // Clear the global content fields
        setContents({});
        setSummaries({});

        // Disable crop dropdown if first record added
        if (activities.length === 0) {
            setSelectedCropId(formData.cropId);
            const selectedCrop = crops.find(c => c.ID === parseInt(formData.cropId));
            setSelectedCropName(selectedCrop?.CropName || '');
        }

        toast.success('Activity added to list successfully');
    };

    const handleEditActivity = (index, languageCode = '') => {
        const activity = activities[index];
        setValue('isPre', activity.IsPre.toString());
        setValue('weekNo', activity.WeekNo.toString());
        setValue('sameActivityForWeeks', activity.SameActivityForWeeks);

        // Set editing state
        setEditingActivityIndex(index);
        setEditingLanguage(languageCode);

        // Get content for the specific language
        const langContent = activityContents[activity.ID]?.[languageCode] || '';
        const langSummary = activitySummaries[activity.ID]?.[languageCode] || '';

        // Set content and summary for the editing language
        const updatedContents = { ...contents };
        const updatedSummaries = { ...summaries };
        updatedContents[languageCode] = langContent;
        updatedSummaries[languageCode] = langSummary;
        setContents(updatedContents);
        setSummaries(updatedSummaries);
    };

    const handleDeleteActivity = (index) => {
        if (window.confirm('Are you sure you want to delete this activity?')) {
            const activity = activities[index];
            const updatedActivities = [...activities];
            updatedActivities.splice(index, 1);
            setActivities(updatedActivities);

            const updatedContents = { ...activityContents };
            const updatedSummaries = { ...activitySummaries };
            delete updatedContents[activity.ID];
            delete updatedSummaries[activity.ID];
            setActivityContents(updatedContents);
            setActivitySummaries(updatedSummaries);

            toast.success('Activity removed from list');
        }
    };

    const onInitialTranslate = async () => {
        if (activities.length === 0) {
            toast.error('Please add at least one activity before translating');
            return;
        }

        const englishLang = getEnglishLanguage();
        const englishLangCode = getLanguageCode(englishLang);

        // Validate all activities have English content
        const missingContent = activities.some(activity => {
            const content = activityContents[activity.ID]?.[englishLangCode] || '';
            const summary = activitySummaries[activity.ID]?.[englishLangCode] || '';
            return !content.trim() || !summary.trim();
        });

        if (missingContent) {
            toast.error('Please ensure all activities have both content and summary in English');
            return;
        }

        setStep('translate');

        const updatedActivityContents = { ...activityContents };
        const updatedActivitySummaries = { ...activitySummaries };

        try {
            await Promise.all(activities.map(async (activity) => {
                const englishContent = activityContents[activity.ID]?.[englishLangCode] || '';
                const englishSummary = activitySummaries[activity.ID]?.[englishLangCode] || '';

                const translated = await callTranslateApi({
                    Content: englishContent,
                    Summary: englishSummary
                });

                if (!updatedActivityContents[activity.ID]) updatedActivityContents[activity.ID] = {};
                if (!updatedActivitySummaries[activity.ID]) updatedActivitySummaries[activity.ID] = {};

                languages.forEach(lang => {
                    const langCode = lang.GoogleLanguageCode || lang.LanguageCode;
                    if (translated.Content[langCode]) {
                        updatedActivityContents[activity.ID][langCode] = translated.Content[langCode];
                    }
                    if (translated.Summary[langCode]) {
                        updatedActivitySummaries[activity.ID][langCode] = translated.Summary[langCode];
                    }
                });
            }));

            setActivityContents(updatedActivityContents);
            setActivitySummaries(updatedActivitySummaries);

            setStep('translations');
            setMainTab('other');
            setMessage(null);
        } catch (error) {
            console.error("Translation error:", error);
            toast.error("An error occurred during translation.");
            setStep('basic');
        }
    };

    const onFinalSave = async () => {
        if (activities.length === 0) {
            toast.error('Please add at least one activity');
            return;
        }

        // Check if we have content for all activities and all languages
        let hasMissingContent = false;
        const missingLanguages = new Set();

        activities.forEach(activity => {
            languages.forEach(lang => {
                const langCode = getLanguageCode(lang);
                const content = activityContents[activity.ID]?.[langCode] || '';
                const summary = activitySummaries[activity.ID]?.[langCode] || '';

                if (!content.trim() || !summary.trim()) {
                    hasMissingContent = true;
                    missingLanguages.add(lang.LanguageName || langCode);
                }
            });
        });

        if (hasMissingContent) {
            const missingNames = Array.from(missingLanguages).join(', ');
            toast.error(`Please check content and summary for: ${missingNames}`);
            return;
        }

        // Prepare CropWisePrePostSowingDet array
        const cropWisePrePostSowingDet = [];
        activities.forEach(activity => {
            languages.forEach(lang => {
                const langCode = getLanguageCode(lang);
                const langId = lang.ID || lang.LanguageID;
                const content = activityContents[activity.ID]?.[langCode] || '';
                const summary = activitySummaries[activity.ID]?.[langCode] || '';

                cropWisePrePostSowingDet.push({
                    IsPre: activity.IsPre === 1, // Convert to boolean
                    WeekNo: activity.WeekNo,
                    ExtendedTillNoOfWeeks: activity.SameActivityForWeeks,
                    Content: content,
                    Summary: summary,
                    LanguageID: langId,
                    LanguageCode: lang.LanguageCode,
                    GoogleLanguageCode: langCode
                });
            });
        });

        // Prepare main payload
        const payload = {
            // ID: activityToEdit?.ID,
            CropID: selectedCropId || getValues('cropId'),
            CropWisePrePostSowingDet: cropWisePrePostSowingDet
        };

        try {
            const token = localStorage.getItem('authToken') || localStorage.getItem('token');

            if (activityToEdit) {
                await updateCropWisePrePost(token, payload);
            } else {
                await addCropWisePrePost(token, payload);
            }

            toast.success(activityToEdit ? 'Activities updated successfully!' : 'Activities added successfully!');

            if (onSaveSuccess) {
                onSaveSuccess();
            }

            setTimeout(() => {
                onClose();
                setMessage(null);
                reset();
                setActivities([]);
                setActivityContents({});
                setActivitySummaries({});
                setSelectedCropId('');
                setSelectedCropName('');
                setEditingActivityIndex(null);
                setEditingLanguage('');
            }, 1200);
        } catch (error) {
            const errorMsg = error?.response?.data?.message || error?.message || 'Failed to save activities';

            if (errorMsg.includes('Duplicate WeekNo')) {
                setError('weekNo', {
                    type: 'manual',
                    message: errorMsg
                });
            }

            toast.error(errorMsg);
        }
    };

    const handleContentChange = (languageCode, content) => {
        setContents(prev => ({
            ...prev,
            [languageCode]: content
        }));
    };

    const handleSummaryChange = (languageCode, summary) => {
        if (summary.length <= 1000) {
            setSummaries(prev => ({
                ...prev,
                [languageCode]: summary
            }));
        }
    };

    const getLanguageCode = (lang) => {
        if (!lang) return '';
        return lang.GoogleLanguageCode || lang.LanguageCode || '';
    };

    const getEnglishLanguage = () => {
        return languages.find(lang => {
            const langCode = getLanguageCode(lang);
            return langCode === 'en' || langCode === 'en-US' || langCode === 'en-GB';
        }) || languages[0]; // Fallback to first language
    };

    const getSelectedLanguageObj = () => {
        return languages.find(lang => getLanguageCode(lang) === selectedLanguage) || {};
    };

    const renderEnglishTab = () => {
        const englishLang = getEnglishLanguage();
        const englishLangCode = getLanguageCode(englishLang);

        return (
            <form>
                {/* Crop Dropdown */}
                <div className="form-grid-container">
                    <div style={{ gridColumn: 'span 2' }}>
                        <label className="form-label">Crop *</label>
                        <select
                            className="form-control"
                            {...register('cropId', { required: 'Please select a crop' })}
                            disabled={activities.length > 0 || !!activityToEdit}
                            value={selectedCropId || getValues('cropId')}
                            onChange={(e) => {
                                setValue('cropId', e.target.value);
                                setSelectedCropId(e.target.value);
                                const crop = crops.find(c => c.ID === parseInt(e.target.value));
                                setSelectedCropName(crop?.CropName || '');
                            }}
                        >
                            <option value="">Select Crop</option>
                            {crops.map(crop => (
                                <option key={crop.ID} value={crop.ID}>
                                    {crop.CropName}
                                </option>
                            ))}
                        </select>
                        {errors.cropId && <span className="error-message">{errors.cropId.message}</span>}
                    </div>
                </div>

                {/* Activity Type Radio - Show when not editing a specific activity */}
                {editingActivityIndex === null && (
                    <div className="mb-20">
                        <label className="form-label">Activity Type *</label>
                        <div className="radio-group">
                            <label className="radio-option">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    value="1"
                                    {...register('isPre', { required: 'Please select activity type' })}
                                />
                                Pre-Sowing
                            </label>
                            <label className="radio-option">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    value="0"
                                    {...register('isPre', { required: 'Please select activity type' })}
                                />
                                Post-Sowing
                            </label>
                        </div>
                        {errors.isPre && <span className="error-message">{errors.isPre.message}</span>}
                    </div>
                )}

                {/* Only show these fields if we're adding a new activity - hide while editing an activity */}
                {editingActivityIndex === null && isPre && (
                    <>
                        {/* Week Number */}
                        <div className="form-grid-container">
                            <div>
                                <label className="form-label">Week Number *</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    {...register('weekNo', {
                                        required: 'Week number is required',
                                        valueAsNumber: true,
                                        min: { value: 1, message: 'Week number must be at least 1' }
                                    })}
                                    placeholder="Enter week number"
                                />
                                {errors.weekNo && <span className="error-message">{errors.weekNo.message}</span>}
                            </div>

                            {/* Same Activity for N weeks */}
                            <div>
                                <label className="form-label">Same Activity for Next 'N' Weeks</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    {...register('sameActivityForWeeks', {
                                        valueAsNumber: true,
                                        min: { value: 0, message: 'Value must be 0 or greater' }
                                    })}
                                    placeholder="Enter number of weeks"
                                />
                                {errors.sameActivityForWeeks && <span className="error-message">{errors.sameActivityForWeeks.message}</span>}
                            </div>
                        </div>

                        {/* English Content */}
                        <div className="mb-20">
                            <label className="form-label">Content ({englishLang?.LanguageName || 'English'}) *</label>
                            <RichTextEditor
                                value={contents[englishLangCode] || ''}
                                onChange={(content) => handleContentChange(englishLangCode, content)}
                                placeholder={`Enter activity content in ${englishLang?.LanguageName || 'English'}`}
                            />
                            {!contents[englishLangCode]?.trim() && (
                                <span className="error-message">Content is required</span>
                            )}
                        </div>

                        {/* English Summary */}
                        <div className="mb-20">
                            <label className="form-label">Summary ({englishLang?.LanguageName || 'English'}) *</label>
                            <textarea
                                className="summary-textarea"
                                value={summaries[englishLangCode] || ''}
                                onChange={(e) => handleSummaryChange(englishLangCode, e.target.value)}
                                placeholder={`Enter summary (max 1000 characters) in ${englishLang?.LanguageName || 'English'}`}
                                maxLength={1000}
                            />
                            <div className="summary-counter">
                                {summaries[englishLangCode]?.length || 0}/1000 characters
                            </div>
                            {!summaries[englishLangCode]?.trim() && (
                                <span className="error-message">Summary is required</span>
                            )}
                        </div>

                        {/* Add Activity Button */}
                        <div className="mb-20">
                            <button
                                type="button"
                                className="btn btn-yellow w-100 d-flex justify-content-center items-center"
                                onClick={handleAddActivity}
                                disabled={!selectedCropId && !getValues('cropId')}
                            >
                                Add Activity
                            </button>
                        </div>
                    </>
                )}

                {/* Edit form for existing activity */}
                {editingActivityIndex !== null && editingLanguage === englishLangCode && (
                    <>
                        <div className="form-grid-container">
                            <div>
                                <label className="form-label">Week Number *</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    {...register('weekNo', {
                                        required: 'Week number is required',
                                        valueAsNumber: true,
                                        min: { value: 1, message: 'Week number must be at least 1' }
                                    })}
                                    placeholder="Enter week number"
                                />
                                {errors.weekNo && <span className="error-message">{errors.weekNo.message}</span>}
                            </div>

                            <div>
                                <label className="form-label">Same Activity for Next 'N' Weeks</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    {...register('sameActivityForWeeks', {
                                        valueAsNumber: true,
                                        min: { value: 0, message: 'Value must be 0 or greater' }
                                    })}
                                    placeholder="Enter number of weeks"
                                />
                                {errors.sameActivityForWeeks && <span className="error-message">{errors.sameActivityForWeeks.message}</span>}
                            </div>
                        </div>

                        <div className="mb-20">
                            <label className="form-label">Content ({englishLang?.LanguageName || 'English'}) *</label>
                            <RichTextEditor
                                value={contents[englishLangCode] || ''}
                                onChange={(content) => handleContentChange(englishLangCode, content)}
                                placeholder={`Enter content in ${englishLang?.LanguageName || 'English'}`}
                            />
                            {!contents[englishLangCode]?.trim() && (
                                <span className="error-message">Content is required</span>
                            )}
                        </div>

                        <div className="mb-20">
                            <label className="form-label">Summary ({englishLang?.LanguageName || 'English'}) *</label>
                            <textarea
                                className="summary-textarea"
                                value={summaries[englishLangCode] || ''}
                                onChange={(e) => handleSummaryChange(englishLangCode, e.target.value)}
                                placeholder={`Enter summary (max 1000 characters) in ${englishLang?.LanguageName || 'English'}`}
                                maxLength={1000}
                            />
                            <div className="summary-counter">
                                {summaries[englishLangCode]?.length || 0}/1000 characters
                            </div>
                            {!summaries[englishLangCode]?.trim() && (
                                <span className="error-message">Summary is required</span>
                            )}
                        </div>

                        {/* Save/Cancel buttons for editing */}
                        <div className="d-flex justify-content-end gap-3 mb-20">
                            <button
                                type="button"
                                className="border border-danger-600 text-danger-600 px-24 py-6 radius-6"
                                onClick={() => {
                                    setEditingActivityIndex(null);
                                    setEditingLanguage('');
                                    setContents({});
                                    setSummaries({});
                                }}
                            >
                                Cancel Edit
                            </button>
                            <button
                                type="button"
                                className="btn btn-yellow px-24 py-6 radius-6"
                                onClick={async () => {
                                    // Validate form
                                    const isValid = await trigger(['weekNo', 'sameActivityForWeeks']);
                                    if (!isValid) return;

                                    const formData = getValues();
                                    const weekNoInt = parseInt(formData.weekNo);
                                    const sameActivityInt = parseInt(formData.sameActivityForWeeks);

                                    const activity = activities[editingActivityIndex];
                                    const isPreInt = activity.IsPre;

                                    // Check for duplicate combination of IsPre and Week No. (excluding current)
                                    const isDuplicate = activities.some((act, idx) =>
                                        idx !== editingActivityIndex &&
                                        act.IsPre === isPreInt &&
                                        act.WeekNo === weekNoInt
                                    );

                                    if (isDuplicate) {
                                        setError('weekNo', {
                                            type: 'manual',
                                            message: 'Activity with this week number already exists for the selected type'
                                        });
                                        toast.error('Activity with this week number already exists');
                                        return;
                                    }

                                    // Update activity details
                                    const updatedActivities = [...activities];
                                    updatedActivities[editingActivityIndex] = {
                                        ...activity,
                                        WeekNo: weekNoInt,
                                        SameActivityForWeeks: sameActivityInt
                                    };
                                    setActivities(updatedActivities);

                                    const updatedContents = { ...activityContents };
                                    const updatedSummaries = { ...activitySummaries };

                                    if (!updatedContents[activity.ID]) updatedContents[activity.ID] = {};
                                    if (!updatedSummaries[activity.ID]) updatedSummaries[activity.ID] = {};

                                    updatedContents[activity.ID][englishLangCode] = contents[englishLangCode] || '';
                                    updatedSummaries[activity.ID][englishLangCode] = summaries[englishLangCode] || '';

                                    setActivityContents(updatedContents);
                                    setActivitySummaries(updatedSummaries);

                                    setEditingActivityIndex(null);
                                    setEditingLanguage('');
                                    setContents({});
                                    setSummaries({});

                                    toast.success('Activity updated successfully');
                                }}
                            >
                                Save Changes
                            </button>
                        </div>
                    </>
                )}

                {/* Activities Table - Always show if there are activities */}
                {activities.length > 0 && (
                    <div className="mb-20">
                        <h6 className="text-primary-light mb-3">
                            List of Pre/Post Sowing Activities for Crop {selectedCropName}
                        </h6>
                        <table className="activity-table">
                            <thead>
                                <tr>
                                    <th>Activity Type</th>
                                    <th>Week No.</th>
                                    <th>Same for N Weeks</th>
                                    <th>English Content</th>
                                    <th>English Summary</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {activities.map((activity, index) => {
                                    const englishContent = activityContents[activity.ID]?.[englishLangCode] || '';
                                    const englishSummary = activitySummaries[activity.ID]?.[englishLangCode] || '';
                                    return (
                                        <tr key={activity.ID}>
                                            <td>{activity.IsPre === 1 ? 'Pre-Sowing' : 'Post-Sowing'}</td>
                                            <td>{activity.WeekNo}</td>
                                            <td>{activity.SameActivityForWeeks}</td>
                                            <td>
                                                <div className="content-preview">
                                                    {englishContent?.substring(0, 30) || 'No content yet'}...
                                                </div>
                                            </td>
                                            <td>
                                                <div className="content-preview">
                                                    {englishSummary?.substring(0, 30) || 'No summary yet'}...
                                                </div>
                                            </td>
                                            <td>
                                                <div className="table-actions">
                                                    <button
                                                        type="button"
                                                        className="edit-btn bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-32-px h-32-px d-flex justify-content-center align-items-center rounded-circle"
                                                        onClick={() => handleEditActivity(index, englishLangCode)}
                                                    >
                                                        <Icon icon="lucide:edit" className="menu-icon" />
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="delete-btn bg-danger-focus text-danger-600 bg-hover-danger-200 fw-medium w-32-px h-32-px d-flex justify-content-center align-items-center rounded-circle"
                                                        onClick={() => handleDeleteActivity(index)}
                                                    >
                                                        <Icon icon="lucide:trash-2" className="menu-icon" />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}

                {/* Buttons for new mode with activities - Show Translate button */}
                {activities.length > 0 && !activityToEdit && (
                    <div className="d-flex justify-content-center gap-3">
                        <button
                            type="button"
                            className="border border-danger-600 text-danger-600 px-56 py-10 radius-8"
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-yellow px-56 py-12"
                            onClick={onInitialTranslate}
                            disabled={loadingLanguages || languages.length === 0}
                            style={{ opacity: (loadingLanguages || languages.length === 0) ? 0.5 : 1 }}
                        >
                            {loadingLanguages ? 'Loading...' : 'Translate'}
                        </button>
                    </div>
                )}

                {/* Buttons for edit mode - Show Translate or Save based on step */}
                {activityToEdit && activities.length > 0 && (
                    <div className="d-flex justify-content-center gap-3">
                        <button
                            type="button"
                            className="border border-danger-600 text-danger-600 px-56 py-10 radius-8"
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                        {step === 'translations' ? (
                            <button
                                type="button"
                                className="btn btn-yellow px-56 py-12"
                                onClick={onFinalSave}
                            >
                                Save Changes
                            </button>
                        ) : (
                            <button
                                type="button"
                                className="btn btn-yellow px-56 py-12"
                                onClick={onInitialTranslate}
                                disabled={loadingLanguages || languages.length === 0}
                                style={{ opacity: (loadingLanguages || languages.length === 0) ? 0.5 : 1 }}
                            >
                                {loadingLanguages ? 'Loading...' : 'Translate'}
                            </button>
                        )}
                    </div>
                )}
            </form>
        );
    };

    const renderOtherLanguagesTab = () => {
        const englishLang = getEnglishLanguage();
        const englishLangCode = getLanguageCode(englishLang);
        const otherLanguages = languages.filter(lang =>
            getLanguageCode(lang) !== englishLangCode
        );
        const selectedLangObj = getSelectedLanguageObj();
        const selectedLangCode = getLanguageCode(selectedLangObj);
        const selectedLangName = selectedLangObj.LanguageName || selectedLangCode;

        if (otherLanguages.length === 0) {
            return (
                <div style={{ textAlign: 'center', padding: '40px 0' }}>
                    <p>No other languages available</p>
                    <button
                        type="button"
                        className="btn btn-yellow px-56 py-12"
                        onClick={onFinalSave}
                    >
                        Save
                    </button>
                </div>
            );
        }

        return (
            <>
                {/* Language Sub-Tabs - Updated style */}
                <div className="lang-tabs">
                    {otherLanguages.map(lang => {
                        const langCode = getLanguageCode(lang);
                        const langName = lang.LanguageName || langCode;
                        const isActive = selectedLanguage === langCode;

                        return (
                            <button
                                key={langCode}
                                type="button"
                                className={`lang-tab ${isActive ? 'active' : ''}`}
                                onClick={() => {
                                    setSelectedLanguage(langCode);
                                    setEditingLanguage('');
                                    setEditingActivityIndex(null);
                                }}
                            >
                                {langName} ({langCode})
                            </button>
                        );
                    })}
                </div>

                {/* Show table for selected language */}
                {selectedLanguage && activities.length > 0 && (
                    <div className="mb-20">
                        <h6 className="text-primary-light mb-3">
                            Activities for {selectedLangName} ({selectedLangCode})
                        </h6>

                        {/* Content editing fields when editing a specific activity */}
                        {editingActivityIndex !== null && editingLanguage === selectedLangCode && (
                            <>
                                <div className="mb-20">
                                    <label className="form-label">Content ({selectedLangName}) *</label>
                                    <RichTextEditor
                                        value={contents[selectedLangCode] || ''}
                                        onChange={(content) => handleContentChange(selectedLangCode, content)}
                                        placeholder={`Enter content in ${selectedLangName}`}
                                    />
                                    {!contents[selectedLangCode]?.trim() && (
                                        <span className="error-message">Content is required</span>
                                    )}
                                </div>

                                <div className="mb-20">
                                    <label className="form-label">Summary ({selectedLangName}) *</label>
                                    <textarea
                                        className="summary-textarea"
                                        value={summaries[selectedLangCode] || ''}
                                        onChange={(e) => handleSummaryChange(selectedLangCode, e.target.value)}
                                        placeholder={`Enter summary (max 1000 characters) in ${selectedLangName}`}
                                        maxLength={1000}
                                    />
                                    <div className="summary-counter">
                                        {summaries[selectedLangCode]?.length || 0}/1000 characters
                                    </div>
                                    {!summaries[selectedLangCode]?.trim() && (
                                        <span className="error-message">Summary is required</span>
                                    )}
                                </div>

                                {/* Save/Cancel buttons for editing */}
                                <div className="d-flex justify-content-end gap-3 mb-20">
                                    <button
                                        type="button"
                                        className="border border-danger-600 text-danger-600 px-24 py-6 radius-6"
                                        onClick={() => {
                                            setEditingActivityIndex(null);
                                            setEditingLanguage('');
                                            setContents({});
                                            setSummaries({});
                                        }}
                                    >
                                        Cancel Edit
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-yellow px-24 py-6 radius-6"
                                        onClick={() => {
                                            const activity = activities[editingActivityIndex];
                                            const updatedContents = { ...activityContents };
                                            const updatedSummaries = { ...activitySummaries };

                                            if (!updatedContents[activity.ID]) updatedContents[activity.ID] = {};
                                            if (!updatedSummaries[activity.ID]) updatedSummaries[activity.ID] = {};

                                            updatedContents[activity.ID][selectedLangCode] = contents[selectedLangCode] || '';
                                            updatedSummaries[activity.ID][selectedLangCode] = summaries[selectedLangCode] || '';

                                            setActivityContents(updatedContents);
                                            setActivitySummaries(updatedSummaries);

                                            setEditingActivityIndex(null);
                                            setEditingLanguage('');
                                            setContents({});
                                            setSummaries({});

                                            toast.success('Activity content updated successfully');
                                        }}
                                    >
                                        Save Content
                                    </button>
                                </div>
                            </>
                        )}

                        {/* Activities Table */}
                        <table className="activity-table">
                            <thead>
                                <tr>
                                    <th>Activity Type</th>
                                    <th>Week No.</th>
                                    <th>Same for N Weeks</th>
                                    <th>{selectedLangName} Content</th>
                                    <th>{selectedLangName} Summary</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {activities.map((activity, index) => {
                                    const langContent = activityContents[activity.ID]?.[selectedLangCode] || '';
                                    const langSummary = activitySummaries[activity.ID]?.[selectedLangCode] || '';
                                    return (
                                        <tr key={activity.ID}>
                                            <td>{activity.IsPre === 1 ? 'Pre-Sowing' : 'Post-Sowing'}</td>
                                            <td>{activity.WeekNo}</td>
                                            <td>{activity.SameActivityForWeeks}</td>
                                            <td>
                                                <div className="content-preview">
                                                    {langContent?.substring(0, 100) || 'No content yet'}...
                                                </div>
                                            </td>
                                            <td>
                                                <div className="content-preview">
                                                    {langSummary?.substring(0, 100) || 'No summary yet'}...
                                                </div>
                                            </td>
                                            <td>
                                                <div className="table-actions">
                                                    <button
                                                        type="button"
                                                        className="edit-btn bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-32-px h-32-px d-flex justify-content-center align-items-center rounded-circle"
                                                        onClick={() => handleEditActivity(index, selectedLangCode)}
                                                    >
                                                        <Icon icon="lucide:edit" className="menu-icon" />
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="delete-btn bg-danger-focus text-danger-600 bg-hover-danger-200 fw-medium w-32-px h-32-px d-flex justify-content-center align-items-center rounded-circle"
                                                        onClick={() => handleDeleteActivity(index)}
                                                    >
                                                        <Icon icon="lucide:trash-2" className="menu-icon" />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}

                {/* Buttons */}
                <div className="d-flex justify-content-center gap-3">
                    <button
                        type="button"
                        className="border border-danger-600 text-danger-600 px-56 py-10 radius-8"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn btn-yellow px-56 py-12"
                        onClick={onFinalSave}
                    >
                        Save
                    </button>
                </div>
            </>
        );
    };

    return (
        <>
            <style>{customStyles}</style>

            <Drawer open={isOpen} direction="right" size={900}>
                <button
                    variant="outline"
                    onClick={onClose}
                    style={{ border: 'none', color: '#000', padding: 0, textAlign: 'end', padding: '15px', position: 'absolute', top: 0, right: 0 }}
                >
                    <Icon icon="lucide:x" className="text-2xl" />
                </button>
                <div className="card-body drawer-content-scroll">
                    <h6 className="text-xxl text-primary-light mb-16">
                        {activityToEdit ? 'Edit Crop Activities' : 'Add New Crop Activities'}
                    </h6>

                    {message && (
                        <div className={message?.type === 'success' ? 'success-message' : 'error-message'}>
                            {message?.text || message}
                        </div>
                    )}

                    {/* Main Tabs: English / Other Languages */}
                    <div className="main-tabs">
                        <button
                            type="button"
                            className={`main-tab ${mainTab === 'english' ? 'active' : ''}`}
                            onClick={() => setMainTab('english')}
                        >
                            English
                        </button>
                        <button
                            type="button"
                            className={`main-tab ${mainTab === 'other' ? 'active' : ''}`}
                            onClick={() => setMainTab('other')}
                            disabled={step !== 'translations' && !activityToEdit}
                            title={step !== 'translations' && !activityToEdit ? 'Translate first to enable' : 'Other languages'}
                        >
                            Other Languages
                        </button>
                    </div>

                    {/* Loading state */}
                    {loadingLanguages ? (
                        <div style={{ textAlign: 'center', padding: 40 }}>
                            <h4>Loading Languages…</h4>
                            <p>Please wait...</p>
                        </div>
                    ) : languages.length === 0 ? (
                        <div style={{ textAlign: 'center', padding: 40 }}>
                            <h4>No Languages Found</h4>
                            <p>Please check if languages are activated in the system</p>
                        </div>
                    ) : (
                        <>
                            {/* Translating loader */}
                            {step === 'translate' && (
                                <div style={{ textAlign: 'center', padding: 40 }}>
                                    <h4>Translating…</h4>
                                    <p>Please wait...</p>
                                </div>
                            )}

                            {/* ENGLISH TAB */}
                            {mainTab === 'english' && step !== 'translate' && renderEnglishTab()}

                            {/* OTHER LANGUAGES TAB */}
                            {mainTab === 'other' && step !== 'translate' && renderOtherLanguagesTab()}
                        </>
                    )}
                </div>
            </Drawer>
        </>
    );
}